<template>
  <div class="main">
    <mt-header
      :title="$t('加入社群2')"
      class="dl_header_white dl_line_bottom"
      fixed
    >
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>

    <div class="container">
      <mt-cell
        v-for="(item, index) in group_chat"
        :key="index"
        :title="item.name + item.addr"
        @click.native="copy($event, item.addr)"
      >
        <img class="copy" src="@/assets/img/ico_fuzhi_bzxq_hui.png" />
      </mt-cell>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import handleClipboard from "@/utils/clipboard";
export default {
  name: "Shequn",
  components: { Toast },
  data() {
    return {
      group_chat: this.$store.state.initInfo.group_chat,
    };
  },
  created() {},
  methods: {
    goback: function () {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    copy: function (event, val) {
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
  },
  watch: {},
};
</script>

<style scoped>
.main {
  padding-top: 40px;
}
.container {
  padding: 0px 10px 10px 10px;
}
.copy {
  width: 20px;
}
</style>
